import { DataFormatted } from '@/modules/Telemedicine/store/ScheduleAppointment/ScheduleAppointment.types'
import { format } from 'date-fns'

class SubmitScheduleAppointmentMapper {
  toPersistence(domainData: DataFormatted) {
    const attendanceDateNormalize = new Date(domainData?.startDate)

    return {
      specialtyId: domainData?.specialtyId || null,
      patientId: domainData?.patient?.patientId,
      appointmentObjectiveKey: domainData?.appointmentObjectiveKey,
      professionalTypeKey: domainData?.professionalTypeKey,
      startDate: format(attendanceDateNormalize, 'dd-MM-yyyy'),
      page: domainData?.page,
      fitIn: domainData?.fitIn,
      professionalId: domainData?.professional?.key || null,
      professionalName: domainData?.professionalName?.toString(),
      theme: domainData?.theme,
      approach: domainData?.theoreticalApproach,
      ageRange: domainData?.ageRange,
      gender: domainData?.gender,
    }
  }
}

export default new SubmitScheduleAppointmentMapper()
